import intlTelInput from 'intl-tel-input'

/**
 * For fields with class `intl-tel-input`, initialize the intl-tel-input library.
 * Assumes
 *   - the field has an id of the form `phone_number_national`
 *   - there is a field with id `phone_number_validation` to display validation errors
 *   - you are expecting a field to submit with the name `phone_number` in E.164 format
 * this will
 *   - Add validation errors to the element with id `${iti.telInput.id}_validation`.
 *   - Add an error state to the field if the number is invalid.
 */
export default function initIntlTelInput () {
  document.querySelectorAll('.intl-tel-input').forEach((input) => {
    if (intlTelInput.getInstance(input)) { // Skip if already initialized
      return
    }

    const iti = intlTelInput(input, {
      allowedNumberTypes: ['MOBILE'],
      hiddenInputs (telInputName) {
        return { phone: telInputName.replace('_national', '') }
      },
      async initialCountryLookup () {
        try {
          const data = await (await fetch('https://ipapi.co/json')).json()
          return data.country_code || 'us' // error responses (e.g. 429) resolve without a country_code
        } catch {
          return 'us'
        }
      },
      loadUtils: () => import('intl-tel-input/utils'),
      numberDisplayFormat: 'NATIONAL',
      placeholderNumberPolicy: 'AGGRESSIVE',
      separateDialCode: false,
    }),

     validationElem = document.getElementById(input.id.replace('_national', '_validation')),

     validate = async () => {
      await iti.promise // isValidNumber() throws until utils have loaded
      if (input.value.trim()) {
        if (iti.isValidNumber()) {
          input.classList.remove('form-field-error')
          validationElem.classList.add('hidden')
        } else {
          input.classList.add('form-field-error')
          validationElem.innerHTML = 'Invalid number'
          validationElem.classList.remove('hidden')
        }
      }
    }

    input.addEventListener('change', validate)
  })
}

// destroy before cache, else the cached snapshot keeps the injected markup
// and re-init double-wraps the input on restore
document.addEventListener('turbo:before-cache', () => {
  document.querySelectorAll('.intl-tel-input').forEach((input) => {
    intlTelInput.getInstance(input)?.destroy()
  })
})
